// @systeme: erreurs-http
// ============================================================================
// toast-copie.ts — chaque notification d'ERREUR porte un bouton « Copier »
// ============================================================================
// FX 2026-11-03 : « ce serait pratique de pouvoir copier en 1 clic les notifs
// d'erreur pour te les partager ». Les 700+ appels `toast.error(...)` du
// client passent par cette surcharge, posée une fois au démarrage (main.tsx) :
// le message, l'adresse de la page et l'heure vont dans le presse-papiers.
// Un message qui n'est pas du texte (nœud React) garde le toast d'origine.

import { toast } from "sonner";

type ErreurToast = typeof toast.error;

const erreurOriginale: ErreurToast = toast.error;

function texteACopier(message: Parameters<ErreurToast>[0]): string | null {
  if (typeof message !== "string" || !message.trim()) return null;
  return [message, `Page : ${window.location.href}`, `Heure : ${new Date().toISOString()}`].join("\n");
}

async function copier(texte: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(texte);
    toast.success("Message d'erreur copié");
  } catch {
    // Presse-papiers asynchrone refusé (contexte non sécurisé, permission) :
    // repli par sélection d'une zone de texte temporaire.
    const zone = document.createElement("textarea");
    zone.value = texte;
    zone.setAttribute("readonly", "");
    zone.style.position = "fixed";
    zone.style.opacity = "0";
    document.body.appendChild(zone);
    zone.select();
    const ok = document.execCommand("copy");
    zone.remove();
    if (ok) toast.success("Message d'erreur copié");
    else toast.info("Copie impossible : sélectionnez le texte de la notification.");
  }
}

toast.error = ((message: Parameters<ErreurToast>[0], data?: Parameters<ErreurToast>[1]) => {
  const texte = texteACopier(message);
  return erreurOriginale(message, {
    duration: 10_000,
    ...(texte ? { action: { label: "Copier", onClick: () => { void copier(texte); } } } : {}),
    ...data,
  });
}) as ErreurToast;
